import { useEffect, useState } from "react";
import Background from "./components/world.js";
import { get } from "../../util/api.js";

const HealthMap = () => {
  const [data, setData] = useState();
  useEffect(() => {
    getHealthMap();
  }, []);

  const getHealthMap = async () => {
    await get(`/statusnap/health-map`, {})
      .then((res) => {
        setData(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return <Background item xs={false} sm={4} md={7} data={data} />;
};

export default HealthMap;
